import axios from "axios";
import Cookies from "universal-cookie";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}


export function getPropertyDefinitions(project_uuid) {
    const url = process.env.REACT_APP_API_BASE_URL + '/property-definitions';
    return axios.get(url, {
        params: { project_uuid },
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function upsertPropertyDefinition(data) {
    const url = process.env.REACT_APP_API_BASE_URL + '/property-definitions/upsert';
    return axios.post(url, data, {
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function deletePropertyDefinition(project_uuid, uuid) {
    const url = process.env.REACT_APP_API_BASE_URL + '/property-definitions/delete';
    return axios.delete(url, {
        data: { project_uuid, uuid },
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}

export function reorderPropertyDefinitions(project_uuid, orders) {
    const url = process.env.REACT_APP_API_BASE_URL + '/property-definitions/reorder';
    return axios.post(url, {
        project_uuid,
        orders
    }, {
        headers: {
            authorization: `Bearer ${getToken()}`
        }
    });
}
